import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import ToggleTabGroup from '../../components/atoms/ToggleTabGroup';
import css from './MetricSideRow.css';

const MetricSideRow = ({ metricName, label, side, onChange, translate }) => {
    const options = [
        {
            option: 'auto',
            label: translate('STATIC.PAGES.DASHBOARD.SHELF.AXIS.SIDE_AUTO'),
            tooltip: translate('STATIC.PAGES.DASHBOARD.SHELF.AXIS.SIDE_HELP'),
        },
        { option: 'left', label: translate('STATIC.PAGES.DASHBOARD.SHELF.AXIS.SIDE_LEFT') },
        { option: 'right', label: translate('STATIC.PAGES.DASHBOARD.SHELF.AXIS.SIDE_RIGHT') },
    ];

    return (
        <div className={css.row}>
            <span className={css.name}>{label}</span>
            <ToggleTabGroup
                options={options}
                selectedOption={side || 'auto'}
                onToggle={option => onChange(metricName, option)}
            />
        </div>
    );
};

MetricSideRow.propTypes = {
    metricName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    side: PropTypes.oneOf(['left', 'right']),
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(MetricSideRow);
